import { useState } from 'react';
import { Search as SearchIcon, MapPin, Clock, DollarSign, SlidersHorizontal, ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

export function SearchPage() {
  const [showFilters, setShowFilters] = useState(false);
  const [dishes, setDishes] = useState('');
  const [maxDistance, setMaxDistance] = useState(10);
  const [maxBudget, setMaxBudget] = useState<number | ''>('');
  const [timeWindow, setTimeWindow] = useState(4);
  
  const handleSearch = () => {
    // TODO: Implement search
    console.log({ dishes, maxDistance, maxBudget, timeWindow });
  };
  
  return (
    <div className="min-h-screen pb-24">
      {/* Header */}
      <header className="sticky top-0 z-10 border-b bg-background/95 px-4 py-4 backdrop-blur supports-[backdrop-filter]:bg-background/80">
        <div className="mx-auto max-w-lg">
          <h1 className="mb-4 font-display text-2xl font-bold">Quero Comer</h1>
          
          {/* Search input */}
          <div className="relative">
            <SearchIcon className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
            <Input
              value={dishes}
              onChange={(e) => setDishes(e.target.value)}
              placeholder="O que você quer comer? (deixe vazio para explorar)"
              className="pl-10 pr-10"
            />
            <button
              onClick={() => setShowFilters(!showFilters)}
              className={cn(
                'absolute right-3 top-1/2 -translate-y-1/2 rounded p-1 transition-colors',
                showFilters ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:text-foreground'
              )}
            >
              <SlidersHorizontal className="h-4 w-4" />
            </button>
          </div>
          
          {/* Filters */}
          {showFilters && (
            <Card className="mt-4 animate-in">
              <CardContent className="space-y-4 p-4">
                {/* Distance */}
                <div className="space-y-2">
                  <div className="flex items-center justify-between">
                    <Label className="flex items-center gap-2">
                      <MapPin className="h-4 w-4" />
                      Distância máxima
                    </Label>
                    <span className="text-sm font-medium">{maxDistance} km</span>
                  </div>
                  <input
                    type="range"
                    min={1}
                    max={50}
                    value={maxDistance}
                    onChange={(e) => setMaxDistance(Number(e.target.value))}
                    className="w-full accent-primary"
                  />
                </div>
                
                {/* Budget */}
                <div className="space-y-2">
                  <Label className="flex items-center gap-2">
                    <DollarSign className="h-4 w-4" />
                    Orçamento máximo
                  </Label>
                  <Input
                    type="number"
                    value={maxBudget}
                    onChange={(e) => setMaxBudget(e.target.value ? Number(e.target.value) : '')}
                    placeholder="Sem limite"
                    min={0}
                  />
                </div>
                
                {/* Time window */}
                <div className="space-y-2">
                  <div className="flex items-center justify-between">
                    <Label className="flex items-center gap-2">
                      <Clock className="h-4 w-4" />
                      Comer nas próximas
                    </Label>
                    <span className="text-sm font-medium">{timeWindow} horas</span>
                  </div>
                  <input
                    type="range"
                    min={1}
                    max={24}
                    value={timeWindow}
                    onChange={(e) => setTimeWindow(Number(e.target.value))}
                    className="w-full accent-primary"
                  />
                </div>
              </CardContent>
            </Card>
          )}
          
          <Button onClick={handleSearch} className="mt-4 w-full">
            <SearchIcon className="h-4 w-4" />
            Buscar
          </Button>
        </div>
      </header>
      
      {/* Results */}
      <main className="mx-auto max-w-lg px-4 py-6">
        {/* Empty state */}
        <div className="flex flex-col items-center justify-center py-12 text-center">
          <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-muted">
            <SearchIcon className="h-8 w-8 text-muted-foreground" />
          </div>
          <h2 className="font-display text-lg font-semibold">Comece sua busca</h2>
          <p className="mt-1 text-muted-foreground">
            Digite o que você quer comer ou deixe em branco para explorar todas as opções disponíveis.
          </p>
        </div>
        
        {/* Results will be rendered here */}
      </main>
    </div>
  );
}

